import React, { FC } from 'react'
import { Box, Grid, Typography, makeStyles } from '@material-ui/core'
import { Link, generatePath } from 'react-router-dom'
import { KB_VIEW_URL } from 'constants/routes'
import { IArticleListItem, ISection } from 'typescript/interfaces/knowledgeBase'

interface IKnowledgeBaseSearchEmpty {
  sections: Array<ISection>
  articles: Array<IArticleListItem>
}

const EMPTY_SEARCH_MESSAGE =
  "Looks like we don't have a direct answer for that just yet! Try browsing through the system sections below to find what you're looking for."

const useStyles = makeStyles((theme) => ({
  message: {
    maxWidth: '40rem',
    textAlign: 'center',
    color: theme.palette.text.primary,
  },
  card: {
    height: '100%',
    padding: '1.25rem',
    borderRadius: '8px',
    backgroundColor: theme.palette.info.light,
  },
  sectionName: {
    color: theme.palette.text.secondary,
  },
  pageLink: {
    display: 'block',
    marginTop: '0.5rem',
    color: theme.palette.text.primary,
    textDecoration: 'none',
    '&:hover': {
      color: theme.palette.text.secondary,
      textDecoration: 'underline',
    },
  },
  emptySection: {
    display: 'block',
    marginTop: '0.5rem',
    color: theme.palette.text.disabled,
  },
}))

const KnowledgeBaseSearchEmpty: FC<IKnowledgeBaseSearchEmpty> = ({ sections, articles }) => {
  const s = useStyles()

  return (
    <Box>
      <Box display="flex" justifyContent="center" mb="2rem">
        <Typography variant="body1" className={s.message}>
          {EMPTY_SEARCH_MESSAGE}
        </Typography>
      </Box>

      <Grid container spacing={4}>
        {sections.map((section) => {
          const sectionPages = articles
            .filter((article) => article.sectionId === section.id)
            .sort((first, second) => first.title.localeCompare(second.title))

          return (
            <Grid item xs={12} sm={6} md={4} key={section.id}>
              <Box className={s.card}>
                <Typography variant="h4" className={s.sectionName}>
                  {section.name}
                </Typography>
                {sectionPages.length === 0 ? (
                  <Typography variant="caption" className={s.emptySection}>
                    No pages yet
                  </Typography>
                ) : (
                  sectionPages.map((article) => (
                    <Typography
                      key={article.id}
                      variant="body2"
                      component={Link}
                      to={generatePath(KB_VIEW_URL, { id: article.id })}
                      className={s.pageLink}
                    >
                      {article.title}
                    </Typography>
                  ))
                )}
              </Box>
            </Grid>
          )
        })}
      </Grid>
    </Box>
  )
}

export default KnowledgeBaseSearchEmpty
